import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FolderPropertyCodes } from 'src/app/core/constantes/folder-property-codes';
import { ColumnType } from 'src/app/models/enums/column-type';
import { FilterType } from 'src/app/models/enums/filter-type';
import { FilterInfos } from 'src/app/models/server/core/filter-infos';
import { Results } from 'src/app/models/server/core/results-T';
import { SortInfos } from 'src/app/models/server/core/sort-infos';
import { Folder } from 'src/app/models/server/folder';
import { ArchivedFoldersService } from 'src/app/services/http/archived-folders.service';
import { ViewsStateService } from 'src/app/services/state/views-state.service';
import { BaseDatasource } from '../../base-datas-list/data-sources/base-datasource';

@Injectable()
export class ArchivingWorkflowDatasource extends BaseDatasource {
    constructor(
        private archivedFoldersService: ArchivedFoldersService,
        private viewsStateService: ViewsStateService
    ) {
        super();
    }

    public override countDatas(): number {
        let selectedView = this.viewsStateService.getSelectedView();

        if (!!selectedView) {
            // TODO
            return 0;
        } else {
            return 0;
        }
    }

    public override listDatas(from: number, size: number, sort: SortInfos, filters: FilterInfos[], generalFilters: FilterInfos[]): Observable<Results<Folder>> {
        let selectedView = this.viewsStateService.getSelectedView();

        if (!!selectedView) {
            if (!!!filters) {
                filters = [
                    {
                        columnName: FolderPropertyCodes.VIEW_ID,
                        value: selectedView.id.toString(),
                        type: ColumnType.List,
                        filterType: FilterType.List,
                        selectionMultiple: false,
                    },
                ];
            } else {
                const index = filters.findIndex((x) => x.columnName === FolderPropertyCodes.VIEW_ID);

                if (index !== -1) {
                    // Supprime le filtre sur le workflow precedant.
                    filters.splice(index, 1);
                }
            }

            return this.archivedFoldersService.folderList(this.viewsStateService.getSelectedView().id, from, size, sort, filters, generalFilters);
        } else {
            return of(Results.empty<Folder>(Folder));
        }
    }

    public override exportDatas(sort: SortInfos, filters: FilterInfos[], generalFilters: FilterInfos[]): Observable<Blob> {
        let selectedView = this.viewsStateService.getSelectedView();

        if (!!selectedView) {
            if (!!!filters) {
                filters = [
                    {
                        columnName: FolderPropertyCodes.VIEW_ID,
                        value: selectedView.id.toString(),
                        type: ColumnType.List,
                        filterType: FilterType.List,
                        selectionMultiple: false,
                    },
                ];
            } else {
                const index = filters.findIndex((x) => x.columnName === FolderPropertyCodes.VIEW_ID);

                if (index !== -1) {
                    // Supprime le filtre sur le workflow precedant.
                    filters.splice(index, 1);
                }
            }

            return this.archivedFoldersService.export(this.viewsStateService.getSelectedView().id, sort, filters, generalFilters);
        } else {
            return of(null);
        }
    }

    public override isFolderContainsIntoList(folder: Folder): boolean {
        // Verifie si le dossier se trouve dans la vue courante.
        let selectedView = this.viewsStateService.getSelectedView();
        const result: boolean = folder.viewId === selectedView.id;
        return result;
    }
}
